import React, { useEffect } from 'react';

import {
  HStack, Spinner, Stack, Text, useToast,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { getUserCompany } from 'api/company';
import { Avatar } from 'components';
import { AccessTypes, MethodTypes } from 'enums/types';
import { policy } from 'polices';
import useCompany from 'stores/useCompany';
import useUser from 'stores/useUser';

export default function CompanyCard({ state }) {
  const { push } = useHistory();
  const { user } = useUser();
  const toast = useToast();
  const {
    setCompany, company, setRefetch, setIsFetching,
  } = useCompany();

  const { isFetching, refetch } = useQuery(['get', 'company'], getUserCompany, {
    onSuccess: ({ data }) => {
      setCompany(data);
    },
    enabled: Boolean(user && !user?.isSuperUser),
  });

  useEffect(() => {
    setRefetch(refetch);
  }, []);

  const onClick = () => {
    const rule = [AccessTypes.Allow, AccessTypes.Related];
    if (rule.includes(policy('company')(MethodTypes.View))) {
      push('/company');
    } else {
      toast({
        status: 'error',
        duration: 5000,
        isClosable: true,
        title: 'Não autorizado!',
        description: 'Você não tem permissão para acessar esta página.',
      });
    }
  };

  useEffect(() => {
    setIsFetching(isFetching);
  }, [isFetching]);

  if (user?.isSuperUser) {
    return null;
  }

  if (isFetching) {
    return (
      <HStack
        onClick={onClick}
        w="100%"
        justifyContent="center"
        alignItems="center">
        <Spinner />
      </HStack>
    );
  }

  return (
    <Stack
      p={4}
      overflow="hidden"
      onClick={onClick}
      alignItems="center"
      justifyContent="center">
      <motion.div
        animate={state}
        variants={{
          short: {
            width: 40,
            height: 40,
          },
          full: {
            width: 100,
            height: 100,
          },
        }}>
        <Avatar
          border="3px solid"
          borderColor="white"
          width="inherit"
          height="inherit"
          src={company.brandUrl}
          size={state === 'short' ? 'sm' : 'xl'}
          name={company.name}
        />
      </motion.div>
      {state === 'full' && (
      <>
        <Text
          noOfLines={1}
          color="white"
          variant="xLargeBold">
          {company.name}
        </Text>
      </>
      )}
    </Stack>
  );
}
